import { PaginatedSearchRequest, ProfileInvite2 } from './../types';
import { request } from 'utils/ajax';
import { PaginationResult } from 'types';
import { toQueryString } from 'utils/url';
import { COUNTRY_CODES, UserSalutation, UserTitle } from '@ygtechnologies/bygr-frontend-component-library';

export interface ProfileInvitationSearchOptions {
    includeAccepted: boolean;
}

export function getProfileInvitations(
    req: PaginatedSearchRequest,
    options: ProfileInvitationSearchOptions
): Promise<PaginationResult<ProfileInvite2>> {
    return request(`api/profileinvitation`, { query: { ...req, ...options } }).then((x) => x.json());
}

export function getProfileInvitationsExportUrl(req: PaginatedSearchRequest, options: ProfileInvitationSearchOptions) {
    return `api/profileinvitation/excel?${toQueryString({ ...req, ...options })}`;
}

export interface ProfileInvitationOptions {
    profileId: number;
    email: string;
    phoneNumber: string;
    firstName: string;
    lastName: string;
    isAdministrator: boolean;
    hasChangeCatalogPermission: boolean;
    inviteeSalutation?: UserSalutation | null;
    inviteeTitle?: UserTitle | null;
    language: string;
    countryCode: keyof typeof COUNTRY_CODES;
}

export function inviteProfileMember(options: ProfileInvitationOptions) {
    return request(`api/profileinvitation`, { body: { ...options }, method: 'POST', json: true });
}

export function resendProfileInvitation(profileInvitationId: number) {
    return request(`api/profileinvitation/${profileInvitationId}/resend`, { method: 'POST', json: true });
}

export function cancelProfileInvitation(profileInvitationId: number) {
    return request(`api/profileinvitation/${profileInvitationId}/cancel`, { method: 'POST', json: true });
}
